import { gql } from 'urql';
import { PRODUCT } from '../client';

// Read per warehouse, never on GET_WAREHOUSES: thirdPartyProviders is a
// non-null field on LDS's extension of Warehouse, so a warehouse LDS has no row
// for would null the whole warehouses list and leave the DMP with none.
export const GET_WAREHOUSE_THIRD_PARTY_PROVIDERS = gql`
  query ${PRODUCT}GetWarehouseThirdPartyProviders($warehouseId: ID!) {
    warehouse(warehouseId: $warehouseId) {
      id
      thirdPartyProviders
    }
  }
`;

// The courier and escalation dialogs read both prefills here, so the one fetch that gates
// Mark also gates the vehicle default: a GM cannot send before the warehouse's class is known.
export const GET_WAREHOUSE_PICKUP_PREFILL = gql`
  query ${PRODUCT}GetWarehousePickupPrefill(
    $warehouseId: ID!
    $provider: ThirdPartyProvider!
  ) {
    warehouse(warehouseId: $warehouseId) {
      id
      lastThirdPartyPickupTime(provider: $provider)
      thirdPartyVehiclePreference(provider: $provider)
    }
  }
`;
